module.exports = __webpack_public_path__ + "static/fonts/Fact-ExpandedExtraBold.ab433a0.woff";